const WebsiteLink = ({ website }) => {
	return (
		<a className="website-link" href={website} target="_blank" rel="noreferrer">
			Go To Webpage
		</a>
	)
}

export default WebsiteLink
